import { jsx as _jsx } from "react/jsx-runtime";
// TODO: Placeholder for image component from Remix
export default function Image(props) {
    return _jsx("img", { ...props });
}
